import styled from 'styled-components';
import { ApButtonIcon, colors } from '@alixpartners/ui-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	overflow: hidden;
`;

export const TreeContainer = styled.div`
	padding: 24px 0 0 24px;
	height: 100%;
`;

export const TreeNav = styled.div`
	height: 48px;
	padding: 12px 16px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-shadow: inset 0px -1px 0px ${colors.grey3};
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	margin-left: auto;

	button {
		margin-left: 8px;
	}
`;

export const TreeNavActions = styled.div`
	display: flex;
	align-items: center;
`;

export const ActionButton = styled(ApButtonIcon)`
	margin: 0 12px;
`;

export const Title = styled.div`
	font-size: 16px;
	font-weight: 400;
	color: ${colors.black};
`;
